import { render, staticRenderFns } from "./Excepciones_Supervisor_Detalle.vue?vue&type=template&id=d9187132"
import script from "./Excepciones_Supervisor_Detalle.vue?vue&type=script&lang=js"
export * from "./Excepciones_Supervisor_Detalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports